import { Filter } from 'bad-words';
import { array } from 'badwords-list';

const tr = array.tr || [];

const customTurkishBadWords = [
    'amk', 'aq', 'sik', 'göt', 'orospu', 'piç', 'ibne', 'yarrak',
    'amcık', 'siktir', 'sikik', 'gerizekalı', 'aptal', 'salak',
    'mal', 'haysiyetsiz', 'şerefsiz', 'pezevenk', 'kavat', 'götveren',
    'yavşak', 'moruk', 'keleş', 'sürtük', 'kahpe', 'fahişe', 'öküz',
    'eşşek', 'gerzek', 'andaval', 'beyinsiz', 'mankafa', 'şıllık',
    'puşt', 'puştu', 'kaltak', 'yarağı', 'yarram', 'amına', 'amını',
    'sikimi', 'sikine', 'siktiğim', 'siktirgit', 'amcığa', 'amcığı',
    'amcığın', 'amcık', 'amı', 'amın', 'amını', 'amına', 'amından',
    'amınik', 'amınoğlu', 'orospu çocuğu', 'fallik', 'amina koyim',
    'amina', 'dolandırıcı', 'sikeyim', 'oç'
];

class TurkishBadWordsFilter extends Filter {
    constructor(options = {}) {
        super(options);

        this.addWords(...customTurkishBadWords);

        this.regex = /[^a-zA-Z0-9ğüşıöçĞÜŞİÖÇ]/g;
        this.replaceRegex = /(\w{0,3})[\w-]/g;
    }

    clean(text) {
        const normalizedText = text
            .toLowerCase()
            .replace(/[ğ]/g, 'g')
            .replace(/[ü]/g, 'u')
            .replace(/[ş]/g, 's')
            .replace(/[ı]/g, 'i')
            .replace(/[ö]/g, 'o')
            .replace(/[ç]/g, 'c');

        return super.clean(normalizedText);
    }
}

export const turkishBadWordsFilter = new TurkishBadWordsFilter();

